/**
 * Verifica se um service bay está disponível para um período específico
 * @param scheduleServiceBays - Lista de agendamentos existentes
 * @param serviceBayId - ID do service bay
 * @param startDate - Data de início do agendamento
 * @param endDate - Data de fim do agendamento
 * @returns true se disponível, false se houver conflito
 *
 * Exemplo de uso:
 * const isAvailable = checkServiceBayAvailability(
 *   scheduleServiceBays,
 *   "service-bay-123",
 *   new Date("2024-01-15T10:00:00"),
 *   new Date("2024-01-15T12:00:00")
 * );
 */
export function checkServiceBayAvailability(
  scheduleServiceBays: Array<{
    serviceBay?: { id?: string };
    startDate?: Date;
    endDate?: Date;
  }>,
  serviceBayId: string,
  startDate: Date,
  endDate: Date
): boolean {
  const hasConflict = scheduleServiceBays.some(schedule => {
    if (!schedule.serviceBay?.id || !schedule.startDate || !schedule.endDate) {
      return false;
    }
    if (schedule.serviceBay.id !== serviceBayId) {
      return false;
    }
    const existingStart = schedule.startDate.getTime();
    const existingEnd = schedule.endDate.getTime();
    const newStart = startDate.getTime();
    const newEnd = endDate.getTime();
    return (
      (newStart >= existingStart && newStart < existingEnd) ||
      (newEnd > existingStart && newEnd <= existingEnd) ||
      (newStart <= existingStart && newEnd >= existingEnd) ||
      (newStart === existingStart && newEnd === existingEnd)
    );
  });
  return !hasConflict;
} 